export default "__VITE_ASSET__BmbADSgD__"